<template>
  <div>
    <el-row :gutter="10">
      <el-col :md="24">
        <el-card
          header="DG"
          shadow="never"
        >
          <DGTable
            v-if="item.dg"
            :item="item"
          />
        </el-card>
      </el-col>
    </el-row>
    <br>
    <el-row :gutter="10">
      <el-col :md="24">
        <el-card
          header="International"
          shadow="never"
        >
          <el-table
            :data="internationalData"
            style="width: 100%"
            size="small"
            striped
            border
          >
            <el-table-column
              prop="edn"
              label="Export Delcaration Number"
            />
            <el-table-column
              prop="description"
              label="Description"
            />
            <el-table-column
              prop="hasValue"
              label="Commercial Value"
              :formatter="(row, col, cellValue) => cellValue > 0 ? 'Yes' : 'No'"
            />
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <br>
    <el-row :gutter="10">
      <el-col :md="24">
        <el-card
          header="Contents"
          shadow="never"
        >
          <ContentsTable :item="item" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import DGTable from './DG'
import ContentsTable from './Contents'
export default {
  components: {
    DGTable,
    ContentsTable
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      internationalData: [{
        edn: this.item.item_edn,
        description: this.item.item_export_desc,
        hasValue: this.item.item_commercial_value
      }]
    }
  }
}
</script>
